export const getServiceAvailability = ({ departureDate, std, minHours, now = new Date() }) => {
    const hoursToClose = Number(minHours) > 0 ? Number(minHours) : 0;

    if (!departureDate || !std || hoursToClose === 0) {
        return true;
    }

    const departureDateTime = new Date(`${departureDate}T${std}`);

    if (Number.isNaN(departureDateTime.getTime())) {
        return true;
    }

    const cutoffTime = new Date(departureDateTime.getTime() - hoursToClose * 60 * 60 * 1000);

    return now < cutoffTime;
};
